import TreeView, {
	type CheckedNodes,
	type Folder,
	type NodeStates,
} from '@vuejs/components/shared/TreeView'
import type { ContentPackageFolder, PackageType } from '@vuejs/services/packages/interfaces'
import { defineComponent, type PropType } from 'vue'

import { toFolder } from './utils'

export default defineComponent({
	name: 'FolderViewPackage',

	props: {
		folders: {
			required: true,
			type: Array as PropType<ContentPackageFolder[]>,
		},
	},

	emits: {
		action: (_action: string, _type: PackageType | string, _id?: number | string) => true,
		bulk: (_checkedNodes: CheckedNodes[]) => true,
	},

	data(): Data {
		return {
			folderState: {
				checked: false,
				visible: true,
			},
		}
	},

	computed: {
		contentPackageFolders(): Folder[] {
			return this.folders.map(toFolder)
		},
	},

	render() {
		return (
			<div class="packages packages__folder_view">
				<div class="packages__container">
					<div class="packages__data-table">
						<TreeView
							additionalClasses="tree__content-packages"
							autoCheckChildren={false}
							checkbox={true}
							data={this.contentPackageFolders}
							dataTest="tree-view-content-packages"
							message="No content package folders"
							onAction={(action: string, type: PackageType | string, id?: number | string) => this.$emit('action', action, type, id)}
							onBulk={(checkedNodes: CheckedNodes[]) => this.$emit('bulk', checkedNodes)}
						/>
					</div>
				</div>
			</div>
		)
	},
})

interface Data {
	folderState: NodeStates
}
